export default {
  flags: {
    acquisition_flow: false,
    alexa: true,
    annual_plan: true,
    apple_signin: true,
    apple_signup: true,
    cms_widgets: true,
    episode_details_endpoint: false,
    facebook_signin: true,
    facebook_signup: true,
    float_cta_btn: true,
    fullstory_enabled: true,
    google_signin: true,
    google_signup: true,
    holiday_promo: false,
    homepage_v2: true,
    mpart_analytics: true,
    old_cta_routing: false,
    onboarding_categories: true,
    qualified_listening: true,
    reset_password_endpoint: true,
    segment_policy: true,
    show_details_endpoint: true,
    test_feature_1: false,
    text_app_new_sub: true,
    tmta_full_modal_desktop: false,
    web_2: false,
    web_v2_edp: true,
    web_v2_sdp: true,
  },
  variables: {
    alexa: {
      link_alexa_skills: 'https://www.amazon.com/dp/B082MT778N/ref=nodl_',
      link_faqs: 'https://luminary.zendesk.com/hc/en-us/categories/360002749573-Alexa',
    },
    qualified_listening: {
      ql_api_path: 'v1/events/listening-stats',
      send_interval: 10,
      update_interval: 300,
    },
  },
};
